// extracted by mini-css-extract-plugin
export default {"pager":"Pager_pager__t72--","button":"Pager_button__MpBg-","label":"Pager_label__YfRDM"};